import React, { useEffect ,useRef,useState} from 'react';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import { useNavigate ,useLocation } from "react-router-dom";
import 'Assets/css/BlckMemb.css';
import { Helmet } from 'react-helmet-async';
import LnchStrtApi from 'Apis/LnchStrtApi';
import GameSvcLinkApi from 'Apis/GameSvcLinkApi';
import IsMntnInqApi from 'Apis/IsMntnInqApi';
import GameLnchMdalUi from 'Utils/GameLnchMdalUi';
import ApiResultModal from 'Components/ApiResultModal';
import AppStrtApi from 'Apis/AppStrtApi';
import { fetchAdPayload, getKstTimestamp, useGtm } from 'hooks/useGtm';
import { isMobile } from 'react-device-detect';
import appLinkChngApi from 'Apis/AppLinkChngApi';
import MembNrmlLogoutApi from 'Apis/MembNrmlLogoutApi';
import MbpAthnTknCrtRqstApi from 'Apis/MbpAthnTknCrtRqstApi';

declare global {
    interface Window {
        fbq?: (...args: any[]) => void;
    }
}

const AppLinkChangeModal = ({
    open,
    message,
    confirmText,
    secondaryText,
    onConfirm,
    onSecondary,
    onClose,
    submitting,
    app,
}: {
    open: boolean;
    message: string;
    confirmText: string;
    secondaryText?: string;
    onConfirm: () => void;
    onSecondary?: () => void;
    onClose: () => void;
    submitting: boolean;
    app?: string;
}) => {
    const isApp = (app || "").toLowerCase() === "app";
    if (!open) return null;

    return (
        <div className='mdalCommWrap'>
            <div className='mdalBg' onClick={onClose}></div>
            <div className={`mdalCommContainer mdalCustomContainer ${isApp ? "appContainer" : ""}`.trim()}>
                <div className='mdalCommCloseBtn' onClick={onClose}><i className="close"></i></div>
                <div className="mdalCtxtInfo">
                    <p
                        dangerouslySetInnerHTML={{
                            __html: message,
                        }}
                    ></p>
                </div>
                <button className='mdalCommAgreeBtn' onClick={onConfirm} disabled={submitting}>
                    <p>{confirmText}</p>
                </button>
                {secondaryText && onSecondary && (
                    <button
                        type="button"
                        className="mdalCommSecondaryBtn"
                        onClick={onSecondary}
                        disabled={submitting}
                    >
                        {secondaryText}
                    </button>
                )}
            </div>
        </div>
    );
};

const AppStrtUi = () => {
    type AppLinkModalConfirmAction = () => void | Promise<void>;
    const TARGET_GAME_SVC_CD = 'BBCAPP';
    const hasStartedRef = useRef(false);
    const appSchemeCleanupHandlerRef = useRef<(() => void) | null>(null);
    const { push: gtmPush } = useGtm();
    const location = useLocation(); 
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const getGameSvcCd = searchParams.get("gameSvcCd") || (location.state as any)?.gameSvcCd || "BBO";
    const getMeltSetYn = searchParams.get("mltSetYn") || (location.state as any)?.mltSetYn || "N";
    const getPageCd = searchParams.get("pageCd") || (location.state as any)?.pageCd || "main";
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const [showLaunchModal, setShowLaunchModal] = useState(false);
    const [launchingState, setLaunchingState] = useState(true);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);
    const [appLinkModalOpen, setAppLinkModalOpen] = useState(false);
    const [appLinkModalMessage, setAppLinkModalMessage] = useState("");
    const [appLinkSubmitting, setAppLinkSubmitting] = useState(false);
    const [appLinkModalConfirmAction, setAppLinkModalConfirmAction] = useState<AppLinkModalConfirmAction | null>(null);
    const [showOtherAccountLogin, setShowOtherAccountLogin] = useState(false);
    const [launchCountdown, setLaunchCountdown] = useState<number | null>(null);

    const launchAppSchemeWithCleanup = (schemeUrl: string) => {
        if (appSchemeCleanupHandlerRef.current) {
            appSchemeCleanupHandlerRef.current();
        }

        let wasBackgrounded = false;

        const cleanupListener = () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            appSchemeCleanupHandlerRef.current = null;
        };

        appSchemeCleanupHandlerRef.current = cleanupListener;

        const closeOrRedirect = () => {
            try {
                window.close();
            } catch (error) {
                // Ignore close failures. Most external browser tabs are not script-closable.
            }

            // Some browsers only allow close after self-target assignment.
            try {
                window.open('', '_self');
                window.close();
            } catch (error) {
                // Ignore close failures and continue with fallback redirect.
            }

            navigate('/Connect/Login', { replace: true });
        };

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                wasBackgrounded = true;
                return;
            }

            if (document.visibilityState === 'visible' && wasBackgrounded) {
                cleanupListener();
                closeOrRedirect();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        window.location.href = schemeUrl;
    };
    const openMbpAthnWindow = async (athnPrpsCd:string = "MTHD_CHNG_APP", loginId:string|null = null) => {
        try {
            const tokenResp = await MbpAthnTknCrtRqstApi(athnPrpsCd, loginId);
            if(tokenResp.apiHdr.code !== "ATHN0000") {
                alert(`${tokenResp.apiHdr.msg}`);
                return;
            }

            const reqKMCISForm = document.createElement("form");
            reqKMCISForm.method = "post";
            reqKMCISForm.action = "https://www.kmcert.com/kmcis/web/kmcisReq.jsp";
            reqKMCISForm.style.display = "none";

            const trCertInput = document.createElement("input");
            trCertInput.type = "hidden";
            trCertInput.name = "tr_cert";
            trCertInput.value = tokenResp.apiBody.kmcTkn;

            const trUrlInput = document.createElement("input");
            trUrlInput.type = "hidden";
            trUrlInput.name = "tr_url";
            trUrlInput.value = `${process.env.REACT_APP_KMC_REDIRECT_URL}`;

            const trVerInput = document.createElement("input");
            trVerInput.type = "hidden";
            trVerInput.name = "tr_ver";
            trVerInput.value = "V2";

            reqKMCISForm.appendChild(trCertInput);
            reqKMCISForm.appendChild(trUrlInput);
            reqKMCISForm.appendChild(trVerInput);
            document.body.appendChild(reqKMCISForm);

            const isMacDesktop = !isMobile && /Mac/i.test(navigator.platform || navigator.userAgent);

            if(isMobile === true || isMacDesktop) {
                reqKMCISForm.target = "";
            }else {
                const KMCIS_window = window.open('', 'KMCISWindow', 'width=425, height=550, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250' );
                if(KMCIS_window == null){
                    // alert(" ※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는 \n    화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다. \n\n※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.");
                    document.body.removeChild(reqKMCISForm);
                    return;
                }
                reqKMCISForm.target = "KMCISWindow";
            }

            reqKMCISForm.submit();
            document.body.removeChild(reqKMCISForm);
        }catch(error:any) {
            alert(error?.message || "본인인증 요청 중 오류가 발생했습니다.");
        }
    }
    const openResultModal = (message: string,onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };

    const openAppLinkModal = (message: string, onConfirm?: AppLinkModalConfirmAction, allowOtherAccountLogin = false) => {
        setAppLinkModalMessage(message);
        setAppLinkModalConfirmAction(() => onConfirm || (() => closeAppLinkModal()));
        setShowOtherAccountLogin(allowOtherAccountLogin);
        setAppLinkModalOpen(true);
    };

    const handleAppLinkModalConfirm = () => {
        const action = appLinkModalConfirmAction || (() => closeAppLinkModal());
        void Promise.resolve(action()).catch((error) => {
            console.error('앱 링크 모달 확인 동작 오류:', error);
        });
    };

    const logoutAndNavigateToAppLogin = async () => {
        if (appLinkSubmitting) return;
        setAppLinkSubmitting(true);
        setAppLinkModalOpen(false);
        try {
            await MembNrmlLogoutApi();
        } catch (error) {
            console.error('로그아웃 처리 중 오류:', error);
        } finally {
            setAppLinkSubmitting(false);
            navigate("/Connect/Login", { replace: true });
        }
    };

    const dismissAppLinkModal = () => {
        void logoutAndNavigateToAppLogin();
    };

    const closeAppLinkModal = async () => {
        if (appLinkSubmitting) return;
        setAppLinkSubmitting(true);
        setAppLinkModalOpen(false);
        try {
            const resp = await appLinkChngApi();
            // const tsKst = getKstTimestamp();
            // const adPayload = await fetchAdPayload( 'BBO');
            gtmPush('AT_GA_App_Start', {
                // ts: tsKst,
                // ...adPayload,
            });
            launchAppSchemeWithCleanup(resp.apiBody.appScheme);
        } catch (error) {
            console.error('앱 링크 변경 중 오류:', error);
            openResultModal('앱 실행 중 오류가 발생했습니다.');
        } finally {
            setAppLinkSubmitting(false);
        }
    };

    const meltSetYn = (location.state as any)?.mltSetYn || new URLSearchParams(location.search).get("mltSetYn") || "N";

    useEffect(() => {
        if (launchCountdown === null || launchCountdown <= 0) {
            return;
        }

        const timerId = window.setInterval(() => {
            setLaunchCountdown((prev) => {
                if (prev === null || prev <= 1) {
                    window.clearInterval(timerId);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => {
            window.clearInterval(timerId);
        };
    }, [launchCountdown]);

    useEffect(() => {
        return () => {
            if (appSchemeCleanupHandlerRef.current) {
                appSchemeCleanupHandlerRef.current();
            }
        };
    }, []);


    const LnchStrtFunc = async (pageCd:string) => {
        try {
            const firstResp = await AppStrtApi(pageCd);

            switch(firstResp.apiHdr.code) {
                case "GAME0000":
                    setLaunchCountdown(10);
                    if (window.fbq) {
                        window.fbq('trackCustom', 'BBO_FB_Game_Start');
                    }
                    // const tsKst = getKstTimestamp();
                    // const adPayload = await fetchAdPayload( 'BBO');
                    try {
                        gtmPush('BBO_GA_Game_Start', {
                            // ts: tsKst,
                            // ...adPayload,
                        });
                    } catch (gtmErr) {
                        if (typeof window !== 'undefined') {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'BBO_GA_Game_Start',
                                // ts: tsKst,
                                // ...adPayload,
                            });
                        }
                    }
                    setShowLaunchModal(true);
                    launchAppSchemeWithCleanup(firstResp.apiBody.appScheme);

                break;
                case"ATHN2008":
                openAppLinkModal(
                    "앱을 이용하시려면 본인인증이 필요합니다.",
                    () => openMbpAthnWindow("MTHD_CHNG_APP"),
                    true,
                );
                break; 
                case "GAME3101":
                    await GameSvcLinkApi(TARGET_GAME_SVC_CD);
                    const retryResp = await AppStrtApi(pageCd);
                    if(retryResp.apiHdr.code === "GAME0000") {
                        if (window.fbq) {
                        window.fbq('trackCustom', 'BBO_FB_Game_Start');
                    }
                    // const tsKst = getKstTimestamp();
                    // const adPayload = await fetchAdPayload( 'BBO');
                    try {
                        gtmPush('AT_GA_App_Start', {
                            // ts: tsKst,
                            // ...adPayload,
                        });
                    } catch (gtmErr) {
                        if (typeof window !== 'undefined') {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'AT_GA_App_Start',
                                // ts: tsKst,
                                // ...adPayload,
                            });
                        }
                    }
                        setShowLaunchModal(true);
                        launchAppSchemeWithCleanup(retryResp.apiBody.appScheme);
                    } else {
                        openResultModal(`${retryResp.apiHdr.msg}`);
                    }
                break;
                case "GAME3112" : 
                    openResultModal(`${langData?.COMM_MAIN_MNTN_MAIN_LBL_00 || ''}`, () => {
                        navigate("/", { replace: true });
                    });
                break;
                case "GAME3121" :
                    openAppLinkModal(`${langData?.RESP_MSG_GAME3121 || ''}`);
                break;
                default:
                    openResultModal(`${firstResp.apiHdr.msg}`);
                break;
            }
        } catch (error:any) {
            if (error?.code === "ATHN2303") {
                return;
            }
            console.error('앱 실행 중 오류:', error);
            openResultModal( "앱 실행 중 오류가 발생했습니다.");
        } finally {
            setLaunchingState(false);
        }
    }

    const startLaunchWithMntnCheck = async () => {
        setLaunchingState(true);
        try {
            const mntnResp = await IsMntnInqApi(TARGET_GAME_SVC_CD);
            const mntnData = mntnResp?.apiBody || [];
            const currentMntn = mntnData?.find((item: any) => item.gameSvcCd?.toUpperCase() === TARGET_GAME_SVC_CD);
            const isMaintenance = !!currentMntn && currentMntn.isMntn === "Y";

            if (isMaintenance) {
                openResultModal(
                    `${langData?.COMM_MAIN_MNTN_MAIN_LBL_00 || ''}\n${langData?.COMM_MAIN_MNTN_TIME_LBL_STRT_00 || ''} ${currentMntn?.mntnStrtDtime || '-'}\n${langData?.COMM_MAIN_MNTN_TIME_LBL_STOP_00 || ''} ${currentMntn?.mntnStopDtime || '-'}`
                ,()=> {
                    navigate("/", { replace: true });
                });
                setLaunchingState(false);
                return;
            }

            await LnchStrtFunc(getPageCd);
        } catch (error) {
            console.error('점검 확인 중 오류:', error);
            openResultModal(langData?.GAME_LAUNCH_ERROR || "앱 실행 중 오류가 발생했습니다.", () => {
                navigate("/", { replace: true });
            });
            setLaunchingState(false);
        }
    };

    useEffect(()=>{
        if (hasStartedRef.current) {
            return;
        }
        if (isLoading || !langData) {
            return;
        }
        hasStartedRef.current = true;
        startLaunchWithMntnCheck();
    },[isLoading, langData]);

    return(
        <>
            <ApiResultModal
                open={resultModalOpen}
                message={resultModalMessage}
                onClose={closeResultModal}
                confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00 || '확인'}
                app="app"
            />
            <AppLinkChangeModal
                open={appLinkModalOpen}
                message={appLinkModalMessage}
                onConfirm={handleAppLinkModalConfirm}
                onSecondary={() => void logoutAndNavigateToAppLogin()}
                onClose={dismissAppLinkModal}
                confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00 || '확인'}
                secondaryText={showOtherAccountLogin ? "다른 계정으로 로그인" : undefined}
                submitting={appLinkSubmitting}
                app="app"
            />
            <div className='loginInputWrap'>
                <Helmet>
                    <title>BE@RBRICK CONNECT - AppStart</title>
                </Helmet>
                <h2>{langData?.GLB_LOGIN_APP_CHK_MSG_00}</h2>
            </div>
            {/* {showLaunchModal && (
                // <GameLnchMdalUi gameMainPageInfoState={null} onClose={() => setShowLaunchModal(false)} langData={langData} />
            )} */}
        </>
    )
}

export default AppStrtUi;